module.exports = __webpack_public_path__ + "img/중국국기.0b961c3b.png";